import type { AccessControlProvider } from "@refinedev/core";
import type { AdminStaffRole } from "../lib/staff-types";
import { authProvider } from "./authProvider";

export const accessControlProvider: AccessControlProvider = {
	can: async ({ resource, action }) => {
		const role = (await authProvider.getPermissions?.({})) as
			| AdminStaffRole
			| null
			| undefined;

		if (!role) {
			return { can: false, reason: "権限がありません。" };
		}

		if (
			resource === "users" ||
			resource === "posts" ||
			resource === "pins" ||
			resource === "reports"
		) {
			if (action === "list" || action === "show") {
				return { can: true };
			}
		}

		if (resource === "staff") {
			if (role !== "admin") {
				return {
					can: false,
					reason: "この操作には管理者権限が必要です。",
				};
			}
			return { can: true };
		}

		if (action === "list" || action === "show") {
			return { can: true };
		}

		return {
			can: role === "admin",
			reason:
				role === "admin" ? undefined : "この操作には管理者権限が必要です。",
		};
	},
};
